import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";

@Component({
	selector: "app-rate-limit-reached",
	templateUrl: "./rate-limit-reached.component.html",
	styleUrls: ["./rate-limit-reached.component.css"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class RateLimitReachedComponent implements OnInit {
	ngOnInit(): void {}
}
